import { DefaultValue, selector } from "recoil"

import { pluginStudioAtom, UIState } from "../atoms/pluginStudioAtom"

// Get the UI state
export const uiStateSelector = selector<UIState>({
  key: "pluginStudio.uiState",
  get: ({ get }) => {
    const state = get(pluginStudioAtom)
    return state.uiState
  },
  set: ({ set, get }, newValue) => {
    set(pluginStudioAtom, (currentState) => {
      if (newValue instanceof DefaultValue) {
        // If resetting, keep the current uiState
        return { ...currentState }
      }
      return {
        ...currentState,
        uiState: newValue,
      }
    })
  },
})
